import { ILimitset } from "../../../components/views/betslipV2/betslip.models";
import { DEFAULT_STAKES } from "../../../components/views/luckyPickV3/helpers/luckyPickConstants";
import {
  TCurrentMeeting,
  TBetslipData,
  IBetslipBetType
} from "../BetslipV3/types/types";

export interface ILuckyPickBetType {
  horses: IBetslipBetType[];
  stake: number;
  odds: number;
  payout: number;
  isPayoutOverLimit: boolean;
}

export interface ILuckyPickBets {
  betType: string;
  stakeToBet: string;
  betCount: number;
  betPotentialReturn: string;
  enabled: boolean;
}

export type TLuckyPickSelection = {
  raceNumber: number;
  raceTime: string;
  horseName: string;
  horseNumber: number;
  odds: number;
  placeOdds: number;
  firstTimer: boolean;
};

export interface ILuckyPick {
  event: TCurrentMeeting;
  luckyPickBettingData: TBetslipData;
  selections: TLuckyPickSelection[];
  winDouble: ILuckyPickBetType;
  placeTreble: ILuckyPickBetType;
  winPlaceDouble: ILuckyPickBetType;
  limits: { [Key: string]: ILimitset } | null;
  totalStake: number;
  totalPayout: number;
  highlightedHorse: IBetslipBetType | null;
  isFetchingLuckyPick: boolean;
}

export const luckyPickInitialState: ILuckyPick = {
  event: {
    date: "",
    id: 0,
    name: ""
  },
  luckyPickBettingData: {
    bets: [],
    spBets: [],
    placeBets: []
  },
  selections: [],
  winDouble: {
    horses: [],
    stake: DEFAULT_STAKES.WIN_DOUBLE,
    odds: 0,
    payout: 0,
    isPayoutOverLimit: false
  },
  placeTreble: {
    horses: [],
    stake: DEFAULT_STAKES.PLACE_TREBLE,
    odds: 0,
    payout: 0,
    isPayoutOverLimit: false
  },
  winPlaceDouble: {
    horses: [],
    stake: DEFAULT_STAKES.WIN_PLACE_DOUBLE,
    odds: 0,
    payout: 0,
    isPayoutOverLimit: false
  },
  limits: null,
  totalStake: 0,
  totalPayout: 0,
  highlightedHorse: null,
  isFetchingLuckyPick: false
};

export interface ISelectedHorses {
  horseList: IBetslipBetType[];
  selectedHorses: IBetslipBetType[];
}

export type TUpdateHorses = {
  horses: IBetslipBetType[];
};

export type TSetTotalStake = {
  stake: number;
};

export type TUpdateStakeForBetType = {
  betType: string;
  stake: number;
};

export type TUpdateHorse = {
  betType: string;
  horse: IBetslipBetType;
  index: number;
};

export type TUpdateHighlightedHorse = {
  horse: IBetslipBetType | null;
};
